//
//
//
//
//
//
//

export default {
    name: "QfPColors",
    props: {
        value: { type: String },
        label: { type: String, default: "Color" },
        disable: { type: Boolean, default: false }
    },
    data() {
        return {
            localValue: null,
            options: [
                { label: this.$t("userInterface.properties.leftAlign"), value: "left" },
                { label: this.$t("userInterface.properties.centerAlign"), value: "center" },
                { label: this.$t("userInterface.properties.rightAlign"), value: "right" }
            ]

        };
    },
    watch: {
        value: {
            handler(val) {
                this.localValue = val;
            },
            immediate: true
        }
    },
    methods: {
        updateValue(value) {
            this.$emit("input", value);
        }
    }
};
